import { render, staticRenderFns } from "./StaffQandA.vue?vue&type=template&id=68d490b2&scoped=true"
import script from "./StaffQandA.vue?vue&type=script&lang=js"
export * from "./StaffQandA.vue?vue&type=script&lang=js"
import style0 from "./StaffQandA.vue?vue&type=style&index=0&id=68d490b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d490b2",
  null
  
)

export default component.exports